import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from "./profile.component";
import { routing } from "./profile.routing";
import {TableModule} from "primeng/table";
import {DialogModule} from "primeng/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MomentModule} from "ngx-moment";
import {ComponentsModule} from "../components/components.module";
import { InputTextModule } from 'primeng/inputtext';
import {TimelineModule} from "primeng/timeline";
import {RecentlyOrderComponent} from "./orders/recently-order/recently-order.component";
import {OrdersComponent} from "./orders/orders.component";
import {DetailsComponent} from "./orders/details/details.component";
import {UserProfileComponent} from "./user-profile/user-profile.component";

@NgModule({
  declarations: [
    ProfileComponent,
    OrdersComponent,
    DetailsComponent,
    RecentlyOrderComponent,
    UserProfileComponent,
  ],
  imports: [
    CommonModule,
    routing,
    TableModule,
    DialogModule,
    ReactiveFormsModule,
    FormsModule,
    MomentModule,
    ComponentsModule,
    InputTextModule,
    TimelineModule
  ]
})

export class ProfileModule { }
